// const API_URL = "http://localhost:3003"
const API_URL = "https://server.wilaya.womi.ma"
export default API_URL
